import React from 'react'
import { SlottableComponent } from '../../../types'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

interface ListingPageProps extends SlottableComponent<'nav' | 'left' | 'main'> {
  className?: string
  elmId?: string
}

const ListingPage = ({ slots, className = '' }: ListingPageProps) => {
  return (
    <div className={cx('container', 'column', className)}>
      {slots?.nav && <div className={cx('nav')}>{slots?.nav?.()}</div>}
      <div className={cx('row')}>
        {slots?.left && <div className={cx('left')}>{slots?.left?.()}</div>}
        {slots?.main && <div className={cx('main')}>{slots?.main?.()}</div>}
      </div>
    </div>
  )
}

export default ListingPage
